import { useTranslation } from "react-i18next";

import styles from "./notFound.module.css";

export default function NotFound() {
  const { t } = useTranslation("components.notFound");
  return <div className={styles.container}>{t("text")}</div>;
}
